import { Button, Chip, Grid, IconButton, Menu, MenuItem, } from '@material-ui/core';
import { Cake, Description, Event, EventBusy, Group, HomeWork, Mail, MoreHoriz, Phone, Room } from '@material-ui/icons';
import { getAbsenceHoursByStudentIdAndClassroomId, getClassesById, getInfosIndividual, getInfosIndividualWithAffiliateStatus } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarStudent from 'components/Avatar/AvatarStudent';
import { useState } from 'react'
import { FormattedDate, FormattedMessage } from 'react-intl';
// import TableActions from './TableActions';
import { ageCalculator, pluralize } from '@webapps/utils';
import { formatPhoneNumber } from 'react-phone-number-input';
import Megaphone from 'components/Icons/Megaphone';
import AvatarCFA from 'pages/CFA/components/AvatarCFA';
import RelationsCardSkeleton from './RelationsCardSkeleton';


const RelationsCard = ({ item }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  if (!item.id) {
    return <RelationsCardSkeleton />
  }
  return (
    <div style={{ padding: spacing(2.5), borderRadius: 16, backgroundColor: '#FFF', display: 'flex', flexDirection: 'column', gap: 16 }} >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <AvatarCFA idUser={item?.cfa?.id} />
        <div>
          <span style={{ display: 'flex', alignItems: 'end' }} className={global.title} >{item?.cfa?.name}</span>
          <div className={cx(global.infoText, classes.address)} style={{ marginTop: 0 }}>
            <Room className={global.infoIcon} />
            {(item?.cfa?.address?.cityCode && item?.cfa?.address?.city) ? `${item?.cfa?.address?.cityCode}, ${item?.cfa?.address?.city}` : 'Non renseigné'}
          </div>
        </div>
      </div>

      <div className={classes.cardItem}>
        <Chip
          classes={{
            colorPrimary: css({
              background: '#dbfad8',
              color: 'green',
            }),
          }}
          className={classes.chip}
          color="primary"
          label="Synchronisation activée"
          size='24px'
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <div className={cx(global.infoText, classes.address)} >
          <Megaphone className={global.infoIcon} />
          <div>{item?.trainingsCount ? `${item?.trainingsCount} ${pluralize('formation', item?.trainingsCount)} ${pluralize('connectée', item?.trainingsCount)} au CFA` : 'Aucune formation connectée'}</div>
        </div>

        <div className={cx(global.infoText, classes.address)} >
          <Mail className={global.infoIcon} />
          <div>{item?.cfa?.email || 'Non renseigné'}</div>
        </div>

        <div className={cx(global.infoText, classes.address)} >
          <Phone className={global.infoIcon} />
          <div>{item?.cfa?.phone ? formatPhoneNumber(item?.cfa?.phone) : 'Non renseigné'}</div>
        </div>
      </div>


    </div>
  )
}

const styles = ({ spacing }) => ({
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  formations: {
    marginTop: spacing(2),
  },
  infoCandidat: { display: 'flex', alignItems: 'center', width: '100%' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  address: {
    marginTop: spacing(0.5),
    display: 'flex',
    // alignItems: 'center',
    '@media (max-width: 430px)': {
      flexDirection: 'column'
    }
  },
  phone: {
    textDecoration: 'none',
    color: '#5A6DA1',
  },
  chip: {
    padding: spacing(2.5),
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'regular',
    '@media only screen and (max-width:768px)': { fontSize: 12, padding: 0, maring: 0 },
  },
  divStudent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  }
});

export default RelationsCard